import { resetarParaEstadoInicial } from 'src/utils/executoras/executoras'

import {
  vuexMapDefaultsMutations
} from 'src/utils.store'

import {
  definirPrevisaoPadraoSemDiaDeTrabalho,
  definirPrevisaoPadraoParaFerias,
  definirPrevisaoPadraoParaAfastamento,
  verificarSeDataEstaEntreOuEhIgual,
  formatarInformacoesDaJornada,
  definirPrevisaoPadraoEmDiaDeTrabalho,
  definirPrevisaoPadraoProximaJornada
} from './utils'

import { criarMomentAPartirDaStore, formatarDataParaStore } from '@/utils/formatadoras/formatadoras'

import { definirDataParaConsultarJornadasComProblemas } from '@/components/Home/utils'

import { API, retryRequest } from 'src/services'
import moment from 'moment'
import { FiltradorDeErros } from 'src/erros'
import { buscarDadosDeFerias, obterRepositorioDeFerias } from '@/components/Home/Components/widgets/feriasDoTime'

const FORMATO_DATA_STORE = 'YYYY-MM-DD'

function formatarDataParaApi (data) {
  return criarMomentAPartirDaStore(data).format(FORMATO_DATA_STORE)
}

function obterDatasDoDia (state) {
  return {
    ontem: criarMomentAPartirDaStore(state.dataOntem),
    hoje: criarMomentAPartirDaStore(state.dataHoje),
    amanha: criarMomentAPartirDaStore(state.dataAmanha)
  }
}

function montarInformacoesJornada (nome, data, jornada) {
  const dataFormatada = formatarDataParaApi(data)

  return {
    nome,
    dataInicio: dataFormatada,
    dataFim: dataFormatada,
    ...jornada
  }
}

function defaultState () {
  return {
    dataInicioMes: null,
    dataFimMes: null,
    mesReferencia: null,
    dataHoje: moment().startOf('day').format(FORMATO_DATA_STORE),
    dataOntem: moment().startOf('day').subtract(1, 'days').format(FORMATO_DATA_STORE),
    dataAmanha: moment().startOf('day').add(1, 'days').format(FORMATO_DATA_STORE),
    pontosDeHoje: {
      loading: false,
      error: false,
      pontos: []
    },
    pontosDeOntem: {
      loading: false,
      error: false,
      pontos: []
    },
    jornadaAnterior: {
      loading: false,
      error: false,
      jornada: null
    },
    jornadaAtual: {
      loading: false,
      error: false,
      jornada: null
    },
    proximaJornada: {
      loading: false,
      error: false,
      jornada: null
    },
    jornadasComProblemas: {
      loading: false,
      error: false,
      quantidade: null
    },
    acompanhamento: {
      loading: true,
      error: false,
      previsao: {}
    },
    jornadasDoMes: {
      dias: [],
      loading: true,
      error: false
    },
    // Lista dos próximos pontos do dia (widget "Próximos pontos"): entrada/pausa/
    // retorno/saída ainda não batidos, sobreaviso e pausas extraordinárias.
    // Ausência (dia sem trabalho) NÃO é reclassificada aqui — o widget reusa
    // acompanhamento.previsao; a action só marca ehDiaDeTrabalho = false.
    proximosPontos: {
      loading: false,
      error: false,
      ehDiaDeTrabalho: true,
      porDuracao: false,
      pontos: [], // [{ tipo, previstoISO, batido, atrasado }]
      sobreaviso: [], // [{ inicio, fim }]
      pausasExtraordinarias: 0
    },
    // Widget "Minhas férias" — próximas férias do próprio empregado (marcadas/
    // pedidas) e o vencimento do saldo dele nos próximos 180 dias.
    minhasFerias: {
      loading: false,
      error: false,
      proximas: [],
      vencimentos: [],
      totalProximas: 0,
      totalVencimentos: 0
    }
  }
}

const getters = { }

const mutations = {
  ...vuexMapDefaultsMutations(defaultState()),
  dataInicioMes (state, payload) {
    state.dataInicioMes = formatarDataParaStore(payload)
  },
  dataFimMes (state, payload) {
    state.dataFimMes = formatarDataParaStore(payload)
  },
  dataHoje (state, payload) {
    state.dataHoje = formatarDataParaStore(payload)
  },
  dataOntem (state, payload) {
    state.dataOntem = formatarDataParaStore(payload)
  },
  dataAmanha (state, payload) {
    state.dataAmanha = formatarDataParaStore(payload)
  },
  resetState (state) {
    resetarParaEstadoInicial(state, defaultState())
  }
}

const actions = {
  async pegarPontos ({rootState, state, commit, dispatch}) {
    const empregado = rootState.userInfo.compemployee
    const datas = obterDatasDoDia(state)
    const params = {
      employees: [empregado.id],
      infoToRefetch: null,
      startDate: formatarDataParaApi(datas.ontem),
      endDate: formatarDataParaApi(datas.hoje)
    }
    commit('pontosDeOntem', { loading: true })
    commit('pontosDeHoje', { loading: true })
    try {
      const res = await retryRequest(API.timesheet.save, {load: 'pts'}, params)
      const { lines } = res.body.success

      const pontosDeOntem =
        lines.find(l => moment(l.data).isSame(datas.ontem, 'day'))
      const pontosDeHoje =
        lines.find(l => moment(l.data).isSame(datas.hoje, 'day'))

      commit('pontosDeOntem', {loading: false, pontos: pontosDeOntem?.timelogs || [], error: false})
      commit('pontosDeHoje', {loading: false, pontos: pontosDeHoje?.timelogs || [], error: false})
      dispatch('pegarAcompanhamento')
      return lines
    } catch (erro) {
      FiltradorDeErros.capturarErro(erro)
      commit('pontosDeOntem', {loading: false, error: true})
      commit('pontosDeHoje', {loading: false, error: true})
    }
  },
  async pegarJornadas ({rootState, state, commit, dispatch}) {
    const empregado = rootState.userInfo.compemployee
    const datas = obterDatasDoDia(state)
    const params = {
      employees: [empregado.id],
      infoToRefetch: null,
      startDate: formatarDataParaApi(datas.ontem),
      endDate: formatarDataParaApi(datas.amanha)
    }
    commit('jornadaAnterior', { loading: true })
    commit('jornadaAtual', { loading: true })
    commit('proximaJornada', { loading: true })
    try {
      const res = await retryRequest(API.timesheet.save, {load: 'djs'}, params)
      const { lines } = res.body.success
      const jornadaAnterior =
        lines.find(l => moment(l.data).isSame(datas.ontem, 'day'))
      const jornadaAtual =
        lines.find(l => moment(l.data).isSame(datas.hoje, 'day'))
      const proximaJornada =
        lines.find(l => moment(l.data).isSame(datas.amanha, 'day'))

      const infomacoesJornadaAnterior = montarInformacoesJornada('jornadaAnterior', datas.ontem, jornadaAnterior)
      const infomacoesJornadaAtual = montarInformacoesJornada('jornadaAtual', datas.hoje, jornadaAtual)
      const infomacoesProximaJornada = montarInformacoesJornada('proximaJornada', datas.amanha, proximaJornada)
      dispatch('tratarJornada', infomacoesJornadaAnterior)
      dispatch('tratarJornada', infomacoesJornadaAtual)
      dispatch('tratarJornada', infomacoesProximaJornada)
    } catch (erro) {
      FiltradorDeErros.capturarErro(erro)
      commit('jornadaAnterior', {loading: false, error: true})
      commit('jornadaAtual', {loading: false, error: true})
      commit('proximaJornada', {loading: false, error: true})
    }
  },
  async pegarJornadasDoMes ({rootState, state, commit}) {
    const empregado = rootState.userInfo.compemployee
    const params = {
      employees: [empregado.id],
      infoToRefetch: null,
      startDate: state.dataInicioMes,
      endDate: state.dataFimMes
    }
    commit('jornadasDoMes', { ...state.jornadasDoMes, loading: true, error: false })
    try {
      const res = await retryRequest(API.timesheet.save, {load: 'djs'}, params)
      const { lines } = res.body.success
      commit('jornadasDoMes', { dias: lines || [], loading: false, error: false })
    } catch (erro) {
      FiltradorDeErros.capturarErro(erro)
      commit('jornadasDoMes', { dias: [], loading: false, error: true })
    }
  },
  async tratarJornada ({commit, dispatch}, jornada) {
    const dataInicio = jornada.dataInicio
    const dataFim = jornada.dataFim
    const jornadaPendente =
        jornada?.dayJourney.journey.name === 'Aguarde, atualizando.'

    const possuiJustificativa = jornada?.dayJourney.journey.justify

    if (jornadaPendente) {
      const { infoToRefetch } = jornada

      await dispatch('gerarJornadasComProblemas', { dataInicio, dataFim })
      const jornadaRecalculada = await dispatch('pegarJornadaRecalculadas', infoToRefetch)
      commit(`${jornada.nome}`, { loading: false, jornada: jornadaRecalculada, error: false })
    } else {
      commit(`${jornada.nome}`, { loading: false, jornada: jornada?.dayJourney, error: false })
    }

    if (possuiJustificativa) {
      const motivo = await dispatch('pegarJustificativaDaJornada', { dataInicio, dataFim })
      commit(`${jornada.nome}`, { jornada: { ...jornada?.dayJourney, motivo } })
    }
  },
  async gerarJornadasComProblemas ({rootState}, { dataInicio, dataFim }) {
    const empregado = rootState.userInfo.compemployee
    try {
      await API.genEmpsDjs.save({
        employees: [empregado.id],
        startDate: dataInicio,
        endDate: dataFim
      })
    } catch (erro) {
      FiltradorDeErros.capturarErro(erro)
    }
  },
  async pegarJornadaRecalculadas (_, parametros) {
    const params = {
      djs: [],
      infoToRefetchList: [parametros],
      recalculate: true,
      toLoad: ['djs', 'tms']
    }

    try {
      const res = await retryRequest(API.timesheetSync.save, undefined, params)
      const { lines } = res.body.success
      /* Aqui pegamos o primeiro e unico item do array, pois a função
      somente é chamada quando é recalculado apenas uma jornada
      */
      const { dayJourney } = lines[0]

      return dayJourney
    } catch (erro) {
      FiltradorDeErros.capturarErro(erro)
    }
  },
  async pegarJustificativaDaJornada ({rootState}, { dataInicio, dataFim }) {
    const empregado = rootState.userInfo.compemployee
    const params = {
      employees: [empregado.id],
      startDate: dataInicio,
      endDate: dataFim
    }
    try {
      const res = await retryRequest(API.timesheet.save, {load: 'justifies'}, params)
      const { lines } = res.body.success
      const { justify: { reason } } = lines[0]

      return reason
    } catch (erro) {
      FiltradorDeErros.capturarErro(erro)
    }
  },
  async pegarJornadasComProblemas ({rootState, state, commit}) {
    const dataHoje = moment()
    const dataInicioMes = criarMomentAPartirDaStore(state.dataInicioMes)
    const dataFimMes = criarMomentAPartirDaStore(state.dataFimMes)
    const { dataInicio, dataFim } = definirDataParaConsultarJornadasComProblemas(dataHoje, dataInicioMes, dataFimMes)

    const empregado = rootState.userInfo.compemployee
    const inicioDoMes = dataInicio.format('YYYY-MM-DD')
    const fimDoMes = dataFim.format('YYYY-MM-DD')
    const params = {
      employees: [empregado.id],
      startDate: inicioDoMes,
      endDate: fimDoMes
    }
    commit('jornadasComProblemas', { loading: true })
    try {
      const res = await retryRequest(API.timesheet.save, {load: 'lines'}, params)
      const { lines } = res.body.success
      const diasComProblemas =
        lines?.filter(linha => {
          const observacao = linha?.timeMeasurements?.apontamentos?.obs?.value
          return observacao && !observacao.includes('Ausência justificada:')
        })

      commit('jornadasComProblemas', { loading: false, quantidade: diasComProblemas?.length, error: false })
    } catch (erro) {
      FiltradorDeErros.capturarErro(erro)
      commit('jornadasComProblemas', { loading: false, error: true })
    }
  },
  async pegarAcompanhamento ({rootState, commit, state, dispatch}) {
    const empregado = rootState.userInfo.compemployee
    const diaCorrente = new Date()
    const { hoje: dataHoje, amanha: dataAmanha } = obterDatasDoDia(state)
    const dataHojeFormatada = formatarDataParaApi(dataHoje)
    const dataAmanhaFormatada = formatarDataParaApi(dataAmanha)
    const pontosDoDia = state.pontosDeHoje.pontos
    const possuiPontoDeEntrada = Boolean(pontosDoDia[0].length)
    const possuiPontoDePausa = Boolean(pontosDoDia[1].length)
    const possuiPontoDeRetorno = Boolean(pontosDoDia[2].length)
    const possuiPontoDeSaida = Boolean(pontosDoDia[3].length)
    const mostrarInicioEFimDaJornada =
      rootState.userInfo.compMan.frontOptions.timesheetDjDisplayText === 'start_end'
    commit('acompanhamento', {loading: true})
    try {
      /*
       Primeiro, verificamos se existe Férias ou Afastamento no dia corrente,
       e, se já possuimos ponto de saida.
      */
      const { vacation, leave } = await dispatch('pegarFeriasEAfastamento')
      const possuiFerias = Boolean(vacation.length)
      const inicioUltimasFerias = moment(vacation[vacation.length - 1]?.start)
      const fimUltimasFerias = moment(vacation[vacation.length - 1]?.end)
      const possuiAfastamento = Boolean(leave.length)
      const hojeEstaNoPeriodoDasFerias = possuiFerias
        ? verificarSeDataEstaEntreOuEhIgual(diaCorrente, inicioUltimasFerias, fimUltimasFerias, 'day')
        : false
      const hojeEstaNoPeriodoDeAfastamento = possuiAfastamento
        ? verificarSeDataEstaEntreOuEhIgual(diaCorrente, moment(leave[0]?.start), 'day')
        : false

      if (possuiFerias && hojeEstaNoPeriodoDasFerias && !possuiPontoDeSaida) {
        const previsaoFerias = definirPrevisaoPadraoParaFerias(vacation[vacation.length - 1])
        commit('acompanhamento', {loading: false, previsao: previsaoFerias})
        return
      }

      if (possuiAfastamento && hojeEstaNoPeriodoDeAfastamento && !possuiPontoDeSaida) {
        const previsaoAcompanhamento = definirPrevisaoPadraoParaAfastamento(leave[0])
        commit('acompanhamento', {loading: false, previsao: previsaoAcompanhamento})
        return
      }
      /* Como sabemos que o dia corrente não é férias ou afastamento,
        vamos recalcular a jornada do dia para garantir consistência.
        Alem disso, agora verificamos se é dispensa, suspensão, folga ou sem jornada
      */
      const paramentrosDj = {
        employees: [empregado.id],
        infoToRefetch: null,
        startDate: dataHojeFormatada,
        endDate: dataHojeFormatada
      }

      const djsRes = await retryRequest(API.timesheet.save, {load: 'djs'}, paramentrosDj)
      const jornada = djsRes.body.success.lines[0]
      if (!jornada) {
        commit('acompanhamento', {loading: false, previsao: {}})
        return
      }
      await dispatch('gerarJornadasComProblemas', {
        dataInicio: dataHojeFormatada,
        dataFim: dataHojeFormatada
      })
      // Se o recálculo falhar (ex.: timesheetSync 500), usa a jornada não-recalculada
      // como fallback para não derrubar o acompanhamento ("erro ao carregar").
      const jornadaDoDiaCorrente =
        (await dispatch('pegarJornadaRecalculadas', jornada.infoToRefetch)) || jornada.dayJourney
      if (!jornadaDoDiaCorrente) {
        commit('acompanhamento', {loading: false, previsao: {}})
        return
      }
      if (!jornadaDoDiaCorrente.isWorkDay) {
        const { isHoliday } = jornadaDoDiaCorrente
        const { justify, suspend } = jornadaDoDiaCorrente.journey

        if (jornadaDoDiaCorrente?.journey?.name === 'Sem jornada') {
          const previsao = definirPrevisaoPadraoSemDiaDeTrabalho('sem jornada')
          commit('acompanhamento', {loading: false, previsao: previsao})
          return
        }
        if (isHoliday) {
          const previsao = definirPrevisaoPadraoSemDiaDeTrabalho('feriado')
          commit('acompanhamento', {loading: false, previsao: previsao})
          return
        }
        if (suspend) {
          const previsao = definirPrevisaoPadraoSemDiaDeTrabalho('suspensao')
          commit('acompanhamento', {loading: false, previsao: previsao})
          return
        }
        if (justify) {
          const motivo =
            await dispatch('pegarJustificativaDaJornada', {
              dataInicio: dataHojeFormatada,
              dataFim: dataHojeFormatada
            })
          const previsao = definirPrevisaoPadraoSemDiaDeTrabalho('dispensa', motivo)
          commit('acompanhamento', {loading: false, previsao: previsao})
          return
        }
        const previsao = definirPrevisaoPadraoSemDiaDeTrabalho('folga')
        commit('acompanhamento', {loading: false, previsao: previsao})
        return
      }
      /*
        Nesta Parte do Fluxo, sabemos que o dia corrente é um dia de trabalho.
        Sendo assim, chamamos a API de acompanhamento
      */
      const res = await API.acompanhamento.get({id: empregado.id})
      const { horariosPrevistos } = res.body

      if (possuiPontoDeSaida) {
        /*
          Como Já temos o ponto de Saída, vamos verificar a próxima Jornada
        */
        const proximaJornada = state.proximaJornada.jornada
        const proximaJornadaEhDiaDeTrabalho = proximaJornada?.isWorkDay

        if (!proximaJornadaEhDiaDeTrabalho) {
          /*
            Caso a próxima jornada não seja jornada de trabalho,
            vamos verificar se existe jornada de trabalho pelos
            próximos 45 dias
          */
          const params = {
            employees: [empregado.id],
            infoToRefetch: null,
            startDate: dataAmanhaFormatada,
            endDate: formatarDataParaApi(dataAmanha.clone().add(45, 'days'))
          }
          let proximaJornadaDeTrabalho
          const djsRes = await retryRequest(API.timesheet.save, {load: 'djs'}, params)
          const jornadas = djsRes.body.success.lines
          const jornadasASeremRecalculadas = jornadas.filter(djs => djs.dayJourney.toBeRecalculated)

          if (jornadasASeremRecalculadas.length) {
            await dispatch('gerarJornadasComProblemas', {
              dataInicio: dataHojeFormatada,
              dataFim: params.endDate
            })
            const infoToRefetch = jornadas.map(dj => dj.infoToRefetch)
            const infoToRefetchParams = {
              djs: [],
              infoToRefetchList: infoToRefetch,
              recalculate: true,
              toLoad: ['djs', 'tms']
            }

            const res = await retryRequest(API.timesheetSync.save, undefined, infoToRefetchParams)
            const jornadasRecalculadas = res.body.success.lines

            proximaJornadaDeTrabalho = jornadasRecalculadas.find(l => l.dayJourney.isWorkDay)
          } else {
            proximaJornadaDeTrabalho = jornadas.find(l => l.dayJourney.isWorkDay)
          }
          if (proximaJornadaDeTrabalho) {
            const proximaJornadaFormatada = formatarInformacoesDaJornada(proximaJornadaDeTrabalho.dayJourney)
            const previsaoProximaJornada =
              definirPrevisaoPadraoProximaJornada('possui jornada', mostrarInicioEFimDaJornada, proximaJornadaFormatada)
            commit('acompanhamento', {loading: false, previsao: previsaoProximaJornada})
            return
          }
          const previsaoSemJornada = definirPrevisaoPadraoProximaJornada('sem jornada')
          commit('acompanhamento', {loading: false, previsao: previsaoSemJornada})
          return
        }
        const proximaJornadaFormatada = formatarInformacoesDaJornada(proximaJornada)
        const previsaoProximaJornada =
            definirPrevisaoPadraoProximaJornada('possui jornada', mostrarInicioEFimDaJornada, proximaJornadaFormatada)

        commit('acompanhamento', {loading: false, previsao: previsaoProximaJornada})
        return
      } else {
        const jornadaAtual = formatarInformacoesDaJornada(jornadaDoDiaCorrente)

        if (!possuiPontoDeEntrada) {
          const dataAgoraEmHoras = moment(diaCorrente).hours()
          const dataInicioJornadaEmHoras = jornadaAtual.inicio.hours()
          const excedeuHorarioPrevisto = moment(dataAgoraEmHoras).isAfter(dataInicioJornadaEmHoras)

          if (excedeuHorarioPrevisto) {
            const previsaoEntradaAtrasada =
              definirPrevisaoPadraoEmDiaDeTrabalho('entrada atrasada', mostrarInicioEFimDaJornada, jornadaAtual)
            commit('acompanhamento', {loading: false, previsao: previsaoEntradaAtrasada})
            return
          }
          const previsaoEntrada =
            definirPrevisaoPadraoEmDiaDeTrabalho('entrada', mostrarInicioEFimDaJornada, jornadaAtual)
          commit('acompanhamento', {loading: false, previsao: previsaoEntrada})
          return
        }

        if (possuiPontoDePausa && !possuiPontoDeRetorno) {
          const retorno = horariosPrevistos.find(h => h.evento === 'horario_retorno')
          const dataAgoraEmHoras = moment.utc(diaCorrente).toISOString()
          const dataRetornoJornadaEmHoras = moment.utc(retorno.horario_utc).toISOString()
          const excedeuHorarioPrevisto = moment(dataAgoraEmHoras).isAfter(dataRetornoJornadaEmHoras)

          if (excedeuHorarioPrevisto) {
            const previsaoRetornoAtrasado =
              definirPrevisaoPadraoEmDiaDeTrabalho('retorno atrasado', mostrarInicioEFimDaJornada, dataRetornoJornadaEmHoras)
            commit('acompanhamento', {loading: false, previsao: previsaoRetornoAtrasado})
            return
          }
          const previsaoRetorno =
            definirPrevisaoPadraoEmDiaDeTrabalho('retorno', mostrarInicioEFimDaJornada, dataRetornoJornadaEmHoras)
          commit('acompanhamento', {loading: false, previsao: previsaoRetorno})
          return
        } else {
          const saida = horariosPrevistos.find(h => h.evento === 'horario_saida')
          const dataAgoraEmHoras = moment.utc(diaCorrente).toISOString()
          const dataSaidaJornadaEmHoras = moment.utc(saida.horario_utc).toISOString()
          const excedeuHorarioPrevisto = moment(dataAgoraEmHoras).isAfter(dataSaidaJornadaEmHoras)

          if (excedeuHorarioPrevisto) {
            const previsaoSaidaAtrasada =
              definirPrevisaoPadraoEmDiaDeTrabalho('saida atrasada', mostrarInicioEFimDaJornada, dataSaidaJornadaEmHoras)
            commit('acompanhamento', {loading: false, previsao: previsaoSaidaAtrasada})
            return
          }
          const previsaoSaida =
              definirPrevisaoPadraoEmDiaDeTrabalho('saida', mostrarInicioEFimDaJornada, dataSaidaJornadaEmHoras)
          commit('acompanhamento', {loading: false, previsao: previsaoSaida})
          return
        }
      }
    } catch (erro) {
      FiltradorDeErros.capturarErro(erro)
      commit('acompanhamento', {loading: false, error: true})
    }
  },
  async pegarFeriasEAfastamento ({rootState}) {
    const empregado = rootState.userInfo.compemployee
    try {
      const res = await API.afastamento.save({}, {
        id: empregado.id,
        getList: true,
        page: 0,
        serach: null
      })

      return res.body.success
    } catch (erro) {
      FiltradorDeErros.capturarErro(erro)
    }
  },
  // Widget "Minhas férias": mesmo trio de consultas do widget do gestor,
  // com entidades restritas ao próprio empregado (tipo 'empregado').
  async pegarMinhasFerias ({ rootState, state, commit }) {
    const empregado = rootState.userInfo.compemployee
    if (!empregado?.id) return

    commit('minhasFerias', { ...state.minhasFerias, loading: true, error: false })
    try {
      const repositorio = await obterRepositorioDeFerias()
      const dados = await buscarDadosDeFerias(
        repositorio,
        { tipo: 'empregado', ids: [empregado.id] },
        new Date()
      )
      commit('minhasFerias', { loading: false, error: false, ...dados })
    } catch (erro) {
      FiltradorDeErros.capturarErro(erro)
      commit('minhasFerias', { ...state.minhasFerias, loading: false, error: true })
    }
  },
  // Monta a lista dos próximos pontos do dia reusando estado já buscado
  // (jornadaAtual + pontosDeHoje) + 1 chamada a horários-previstos. O
  // deslocamento por duração já vem resolvido do servidor em horario_utc — o
  // front NÃO recalcula nada. Dispara no created() e é re-disparada pelo
  // watch('jornadaAtual') do HomeEmpregado quando a jornada do dia chega.
  async pegarProximosPontos ({ rootState, state, commit }) {
    const empregado = rootState.userInfo.compemployee
    const jornadaDoDia = state.jornadaAtual

    // A jornada do dia (pegarJornadas) não é aguardada no created(); enquanto
    // ela não chega mantém carregando — o watch('jornadaAtual') re-dispara esta
    // action quando a jornada estiver pronta.
    if (jornadaDoDia.loading) {
      commit('proximosPontos', { ...state.proximosPontos, loading: true, error: false })
      return
    }
    if (jornadaDoDia.error) {
      commit('proximosPontos', { ...state.proximosPontos, loading: false, error: true })
      return
    }

    commit('proximosPontos', { ...state.proximosPontos, loading: true, error: false })
    try {
      const dayJourney = jornadaDoDia.jornada
      const porDuracao = rootState.userInfo.compMan.frontOptions?.timesheetDjDisplayText !== 'start_end'
      const sobreavisoLigado = rootState.modulosEFuncionalidades.funcionalidades.sobreaviso?.enabled
      const onCall = sobreavisoLigado ? (dayJourney?.onCallJourney || []) : []
      const sobreaviso = onCall.map(periodo => ({ inicio: periodo.startTime, fim: periodo.endTime }))

      // Dia sem trabalho (folga/feriado/férias/afastamento/etc.) ou jornada
      // ausente: o estado de ausência é montado pelo widget a partir de
      // acompanhamento.previsao; aqui só sinalizamos ehDiaDeTrabalho = false.
      if (!dayJourney?.isWorkDay) {
        commit('proximosPontos', {
          loading: false,
          error: false,
          ehDiaDeTrabalho: false,
          porDuracao,
          pontos: [],
          sobreaviso,
          pausasExtraordinarias: 0
        })
        return
      }

      const pontosDoDia = state.pontosDeHoje.pontos || []
      // A jornada planejada tem só 1 par de pausa (stPause/endPause); pausas
      // além disso são extraordinárias.
      const pausasExtraordinarias = Math.max(0, (pontosDoDia[1]?.length || 0) - 1)

      const res = await API.acompanhamento.get({ id: empregado.id })
      const previstos = (res.body.horariosPrevistos || []).reduce((mapa, horario) => {
        mapa[horario.evento] = horario.horario_utc
        return mapa
      }, {})

      const jornada = dayJourney.journey || {}
      const agora = moment()
      const construirPonto = (tipo, valor, batido) => {
        const data = valor ? moment(valor) : null
        const previstoISO = data && data.isValid() ? data.toISOString() : null
        return {
          tipo,
          previstoISO,
          batido: Boolean(batido),
          atrasado: Boolean(previstoISO && !batido && agora.isAfter(data))
        }
      }
      // Entrada/pausa: horariosPrevistos pode não trazer o evento; cai para a
      // jornada planejada (journey.start/stPause). Retorno/saída vêm do back já
      // deslocados por duração em horario_utc.
      const pontos = [
        construirPonto('entrada', previstos.horario_entrada || jornada.start, (pontosDoDia[0]?.length || 0) > 0),
        construirPonto('pausa', previstos.horario_pausa || jornada.stPause, (pontosDoDia[1]?.length || 0) > 0),
        construirPonto('retorno', previstos.horario_retorno || jornada.endPause, (pontosDoDia[2]?.length || 0) > 0),
        construirPonto('saida', previstos.horario_saida || jornada.end, (pontosDoDia[3]?.length || 0) > 0)
      ].filter(ponto => ponto.previstoISO)

      commit('proximosPontos', {
        loading: false,
        error: false,
        ehDiaDeTrabalho: true,
        porDuracao,
        pontos,
        sobreaviso,
        pausasExtraordinarias
      })
    } catch (erro) {
      FiltradorDeErros.capturarErro(erro)
      commit('proximosPontos', { ...state.proximosPontos, loading: false, error: true })
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions
}
